import { render, staticRenderFns } from "./RefundModal.vue?vue&type=template&id=06680f26&scoped=true"
import script from "./RefundModal.vue?vue&type=script&lang=js"
export * from "./RefundModal.vue?vue&type=script&lang=js"
import style0 from "./RefundModal.vue?vue&type=style&index=0&id=06680f26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06680f26",
  null
  
)

export default component.exports